import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { customDiscoveryDefinitions } from '../../../snippets/customDiscoveryDefinitions';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const customDiscoveryDefinitionsGroup = createFormSnippetGroup({
  snippets: {
    customDiscoveryDefinitions,
  },
  render: ({ renderSnippet }) => (
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        Custom Discovery Data
      </div>
      <SearchableSection
        id='custom-discovery-definitions'
        searchTerms={['Definitions', 'YAML']}
        highlightOn={['customDiscoveryData']}
      >
        {renderSnippet('customDiscoveryDefinitions')}
      </SearchableSection>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('customDiscoveryData');
  },
});
